export default __webpack_public_path__ + "static/media/CH0165.9fa689ff.png";